import React, { useEffect } from 'react';
import { Container } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import '../Features.css';

const Text = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.getElementById('home').classList.add('featureContent');
    return () => {
      document.getElementById('home').classList.remove('featureContent');
    };
  });
  useEffect(() => {
    setTimeout(() => {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }, 100);
  }, []);
  return (
    <Container className="featurePages texts">
      <div className="header">
        <div className="headerContent">
          <h2 className="title">{t('contents:textTitle1')}</h2>
          <p className="text">
            {t('contents:textParagraph1')}
            <br />
            {t('contents:textParagraph2')}
          </p>
        </div>
        <img src={require('../../../assets/images/features/pages/text/text_01.png')} />
      </div>
      <div className="content">
        <div className="container">
          <div className="section section01">
            <div className="textBox">
              <p>
                {t('contents:textParagraph3')}
                <br />
                {t('contents:textParagraph4')}
                <br />
                {t('contents:textParagraph5')}
                <br />
                <br />
              </p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/text/add text.png')} />
            </div>
          </div>
          <div className="section section02">
            <div className="textBox">
              <h2 className="title">{t('contents:textTitle2')}</h2>
              <p>
                {t('contents:textParagraph6')}
                <br />
                {t('contents:textParagraph7')}
              </p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/text/text box.jpg')} />
            </div>
          </div>
          <div className="section section03">
            <div className="textBox">
              <h2 className="title">{t('contents:textTitle3')}</h2>
              <p>
                {t('contents:textParagraph8')}
                <br />
                {t('contents:textParagraph9')}
              </p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/text/vibino-feature-Add text-pic3.jpg')}
              />
            </div>
          </div>
          <div className="section section04">
            <div className="textBox">
              <h2 className="title">{t('contents:textTitle4')}</h2>
              <p>{t('contents:textParagraph10')}</p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/text/vibino-feature-Add text-pic5.jpg')}
              />
            </div>
          </div>
          <div className="section section05">
            <div className="textBox">
              <h2 className="title">{t('contents:textTitle5')}</h2>
              <p>{t('contents:textParagraph11')}</p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/text/vibino-feature-Add text-pic4.png')}
              />
            </div>
          </div>
        </div>
        <div className="footer"></div>
      </div>
    </Container>
  );
};

export default Text;
